export default class BowMath {
  static calculatePercentagePowerArrow(pullArrowStartTime: Date, bowTimeToFullPower:Date, strength:number) {
        if (pullArrowStartTime === undefined || pullArrowStartTime === null) {
          return 0;
        }
        let msPerLevel = 10;
        let totalStrTime = strength * msPerLevel;
        let time: Date = new Date();
        let pullTime = time.getTime() - pullArrowStartTime.getTime();

        let bowTimePower = bowTimeToFullPower.getSeconds() * 1000 - totalStrTime;

        if (bowTimePower <=0){
          return 100; // Currently maxed in 100 as 100%.
        } 
        
        let percentagePower = (100 * pullTime) / bowTimePower;
        return Math.trunc(percentagePower);
  }
}
